export * from "./listas";
